import React, { memo } from 'react'
import moment from 'moment-timezone'
import { RangeDatePicker } from 'transfix-ui/components/RangeDatePicker'
import {
  IDateCriteria,
  ISpotBiddingRule,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { FORMATS } from 'constants/datetime'

interface IDateRangeProps {
  value: IDateCriteria
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  error?: string
}

export const DateRange = memo<IDateRangeProps>(({ error, onChange, value }) => {
  const { rangeEnd = '', rangeStart = '' } = value
  const dates: Date[] = []
  const yesterday = (() => {
    const date = new Date()
    date.setDate(date.getDate() - 1)
    return date
  })()

  const addDate = (date: string) => {
    const [startYear, startMonth, startDay] = date.split('-').map(e => Number(e))
    dates.push(new Date(startYear, startMonth - 1, startDay))
  }
  if (rangeStart) addDate(rangeStart)
  if (rangeEnd) addDate(rangeEnd)

  const dateHandler = (dateArr: Date[]) => {
    const start = dateArr[0] ? moment(dateArr[0]).format(FORMATS.yearFirst) : undefined
    const end = dateArr[1] ? moment(dateArr[1]).format(FORMATS.yearFirst) : undefined
    onChange({
      dateCriteria: {
        rangeStart: start,
        rangeEnd: end,
      },
    })
  }

  return (
    <div className='col-md-6 col-xs-4'>
      <RangeDatePicker
        label='Select Date(s)'
        placeholder='Double click for single date'
        dates={dates}
        onDateChange={dateHandler}
        minDate={yesterday}
        dateFormat='m-d-Y'
        large
        validationMessage={error}
        invalid={!!error}
      />
    </div>
  )
})
